import { defineComponent, h } from "vue";
import { cx } from "../utils.js";

export default defineComponent({
	name: "GnChipGroup",
	setup(_, { attrs, slots }) {
		return () => h("div", { ...attrs, class: cx("chip-group", attrs.class) }, slots.default?.());
	}
});
